import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WindowSizeProvider } from "../src/Context/WindowSizeContext";
import App from "./App";
import "./index.css";
const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <WindowSizeProvider>
      <App />
    </WindowSizeProvider>
  </QueryClientProvider>
);
